import React, { useCallback, useEffect } from 'react';
import { useFocusFieldEvent } from '../../../contexts/events-context';
import { useTranslation } from '../../../contexts/translation-context';
import { TextInputWUT } from '../../../inputs/text-input-wut/text-input-wut';
import { SignatureFormat } from '../signature-types';
import { decodeDataUrl, dataUrlToWixFile, encodeDataUrl } from '../utils/data-url';
import styles from './signature-text-wut.module.scss';
export const SignatureTextWUT = _ref => {
  let {
    value,
    onChange,
    inputId,
    fieldId,
    hasError,
    required,
    readOnly,
    onBlur,
    onBeforeChange,
    ariaLabel,
    ariaDescribedBy
  } = _ref;
  const {
    t
  } = useTranslation();
  useFocusFieldEvent(() => {
    const input = document.getElementById(inputId);
    input == null || input.focus({
      preventScroll: true
    });
  }, fieldId);
  const decodedValue = value != null && value.url ? decodeDataUrl(value.url) : undefined;
  const {
    data: signatureText = ''
  } = decodedValue ?? {
    mimeType: '',
    data: ''
  };
  useEffect(() => {
    if (!value) {
      const input = document.getElementById(inputId);
      if (input) {
        input.value = '';
      }
    }
  }, [value, inputId]);
  const handleChange = useCallback(text => {
    onBeforeChange == null || onBeforeChange();
    if (text.trim()) {
      onChange == null || onChange(dataUrlToWixFile(encodeDataUrl({
        data: text,
        mimeType: SignatureFormat.TEXT
      })));
    } else {
      onChange == null || onChange(null);
    }
  }, [onBeforeChange, onChange]);
  return /*#__PURE__*/React.createElement(TextInputWUT, {
    inputId: inputId,
    fieldId: fieldId,
    type: "text",
    value: signatureText,
    onChange: handleChange,
    onBlur: onBlur,
    placeholder: t('field.signature.text.placeholder'),
    hasError: hasError,
    required: required,
    readOnly: readOnly,
    "aria-label": ariaLabel,
    ariaDescribedBy: ariaDescribedBy,
    className: styles.input,
    dataHook: "signature-text"
  });
};
//# sourceMappingURL=signature-text-wut.js.map